/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Practice_Transcript_Better_PhrasingInputs */



/**
* | output |
* | --- |
* | "“{text}”" |
*
* @param {Practice_Transcript_Better_PhrasingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_transcript_better_phrasing = /** @type {((inputs: Practice_Transcript_Better_PhrasingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Transcript_Better_PhrasingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`“${i?.text}”`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`« ${i?.text} »`)
	return /** @type {LocalizedString} */ (`“${i?.text}”`)
});